/**
 * @generated SignedSource<<657f7c40cddbbf48d8bb6c3350c5b0eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserAbTest_userAbTest$data = {
  readonly isActive: boolean | null;
  readonly isInVariant: boolean | null;
  readonly testName: string | null;
  readonly variantPercentage: number | null;
  readonly " $fragmentType": "useUserAbTest_userAbTest";
};
export type useUserAbTest_userAbTest$key = {
  readonly " $data"?: useUserAbTest_userAbTest$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserAbTest_userAbTest">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserAbTest_userAbTest",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "testName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "variantPercentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInVariant",
      "storageKey": null
    }
  ],
  "type": "UserAbTest",
  "abstractKey": null
};

(node as any).hash = "42d5359d5967eac83fa4515e9aa17adc";

export default node;
